import { useContext } from 'react'

import { FeatureFlagContext } from '@context/FeatureFlagContext'

const useFeatureFlagContext = () => {
    return useContext(FeatureFlagContext)
}

export default useFeatureFlagContext
